import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=4f6ad652&scoped=true&"
import script from "./Editor.vue?vue&type=script&lang=js&"
export * from "./Editor.vue?vue&type=script&lang=js&"
import style0 from "./Editor.vue?vue&type=style&index=0&id=4f6ad652&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6ad652",
  null
  
)

component.options.__file = "www/vues/common/editor/Editor.vue"
export default component.exports